<form>
    <mat-form-field class="malou-filled-form-field w-full">
        <input
            class="ml-3"
            matInput
            autocapitalize="off"
            attr.aria-label="{{ 'maloupe.diagnostic_search.common.instagram.placeholder' | translate }}"
            [placeholder]="'maloupe.diagnostic_search.common.instagram.placeholder' | translate"
            [matAutocomplete]="autocomplete"
            [formControl]="instagramControl()" />
        <div class="flex items-center pl-7" matPrefix>
            <img
                class="h-5 w-5 rounded"
                alt="instagram logo"
                [src]="
                    instagramPage() && (instagramPageValidated() || isPrefilledInstagramPageValid())
                        ? instagramProfilePictureUrl()
                        : (PlatformKey.INSTAGRAM | logoPathResolver: { folder: 'platforms' })
                " />
        </div>
        <mat-autocomplete (optionSelected)="validateInstagramPage()" #autocomplete="matAutocomplete">
            @if (instagramPage()) {
                <mat-option [value]="instagramPageName()">
                    <div class="ml-3 flex items-center gap-4">
                        <img class="h-5 w-5 rounded" [src]="instagramProfilePictureUrl()" />
                        <div class="flex flex-col">
                            <span class="malou-text-12--semibold text-malou-blue">
                                {{ instagramPageName() }}
                            </span>
                            <span class="malou-text-9--regular text-malou-text">
                                {{ instagramPageDescription() }}
                            </span>
                        </div>
                    </div>
                </mat-option>
            } @else if (!instagramPage() && instagramControl().value) {
                <mat-option disabled>
                    <span class="malou-text-9--regular ml-3 italic">{{
                        'maloupe.diagnostic_search.common.instagram.not_found' | translate
                    }}</span>
                </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
</form>
